import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisIconRegistry } from './icon-registry.service';
import { IrisIconComponent } from './icon.component';

@NgModule({
  declarations: [IrisIconComponent],
  imports: [CommonModule],
  exports: [IrisIconComponent],
  providers: [IrisIconRegistry]
})
export class IrisIconModule {}
